function _extends() {
  return _extends = Object.assign || function (a) {
    for (var b, c = 1; c < arguments.length; c++) {
      for (var d in b = arguments[c], b) {
        Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
      }
    }

    return a;
  }, _extends.apply(this, arguments);
}

import React from "react";
import * as vl from "vega-lite";
import Vega from "react-vega";

var VegaLite = function VegaLite(a) {
  var b = _extends({}, a),
      c = a.spec,
      d = a.data,
      e = _extends({}, c);

  return d && (e.data = d, delete b.data), b.spec = vl.compile(e).spec, React.createElement(Vega, b);
};

VegaLite.propTypes = Vega.propTypes;
export default VegaLite;